import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'

import '@radix-ui/themes/styles.css'
import './styles/theme.css'
import './styles/radix-theme.css'
import './assets/prototype.css'
import './index.css'
import App from './App.tsx'
import { ThemeProvider } from './components/ThemeProvider'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>
)